import {ISSUES} from './issues';
import {rnd,shuffle} from '../engine/rng';

export const STATES:any={
 bw:{n:'Baden-Württemberg',v:6,age:0,urb:0,ind:.4,g:'OA',alt:'BU'},
 by:{n:'Bayern',v:6,age:0,urb:0,ind:.3,g:'BU',alt:'BU'},
 be:{n:'Berlin',v:4,age:-.2,urb:.6,ind:0,g:'PdA',alt:'OA'},
 bb:{n:'Brandenburg',v:4,age:.35,urb:0,ind:0,g:'PdA',alt:'PdA'},
 hb:{n:'Bremen',v:3,age:-.2,urb:.6,ind:0,g:'PdA',alt:'PdA'},
 hh:{n:'Hamburg',v:3,age:-.2,urb:.6,ind:0,g:'YOU',alt:'PdA'},
 he:{n:'Hessen',v:5,age:0,urb:.1,ind:.1,g:'BU',alt:'BU'},
 mv:{n:'Mecklenburg-Vorpommern',v:3,age:.35,urb:0,ind:0,g:'PdA',alt:'PdA'},
 ni:{n:'Niedersachsen',v:6,age:.05,urb:0,ind:.1,g:'YOU',alt:'BU'},
 nw:{n:'Nordrhein-Westfalen',v:6,age:0,urb:.1,ind:.3,g:'BU',alt:'BU'},
 rp:{n:'Rheinland-Pfalz',v:4,age:.1,urb:0,ind:0,g:'YOU',alt:'BU'},
 sl:{n:'Saarland',v:3,age:.2,urb:0,ind:.2,g:'BU',alt:'PdA'},
 sn:{n:'Sachsen',v:4,age:.35,urb:0,ind:.1,g:'BU',alt:'BU'},
 st:{n:'Sachsen-Anhalt',v:4,age:.35,urb:0,ind:0,g:'BU',alt:'BU'},
 sh:{n:'Schleswig-Holstein',v:4,age:.1,urb:0,ind:0,g:'YOU',alt:'BU'},
 th:{n:'Thüringen',v:4,age:.35,urb:0,ind:0,g:'LB',alt:'LB'},
};
export const BRV:any=69;
/** Startregierung eines Landes zufällig, aber plausibel: meist die traditionelle Partei oder die Alternative, manchmal eine andere.
 * allowYou=false: keine Landesregierung für die eigene Partei (Mehrspieler, beide Parteien starten bei null). */
export function pickGov(st:any,allowYou=true):string{
  const pool:[string,number][]=[[st.g==='YOU'&&!allowYou?st.alt:st.g,4],[st.alt,3],['BU',1.4],['PdA',1.4]];
  if(st.urb>.3)pool.push(['OA',1.6]);if(st.ind>=.3)pool.push(['OA',.6],['LR',.4]);if(st.age>=.3)pool.push(['LB',.9],['HO',.9]);
  const sum=pool.reduce((s,x)=>s+x[1],0);let r=rnd()*sum;for(const [g,w] of pool){if((r-=w)<0)return g}return pool[0][0];
}
export function initStates(){const gov:any={},off:any={};for(const id in STATES){gov[id]=pickGov(STATES[id]);off[id]=Math.round((rnd()*8-4)*10)/10}return{gov,stOff:off,ltwQ:shuffle(Object.keys(STATES)),ltwNext:3}}

export const ISS=Object.fromEntries(ISSUES.map((i:any)=>[i.id,i]));


